'use client';

import React from 'react';
import Image from 'next/image';
import classNames from 'classnames';

export default function Logo({
  className,
  height = 38,
  priority,
  sizes = '110px',
  variant,
  width = 110,
}: {
  variant: 'white' | 'gradient';
  width?: number;
  height?: number;
  className?: string;
  priority?: boolean;
  sizes?: string;
}): React.ReactElement {
  const src = `/trustiLogo${variant === 'white' ? 'White' : 'Gradient'}.svg`;

  return (
    <Image
      src={src}
      width={width}
      height={height}
      alt="trusti logo"
      sizes={sizes}
      className={classNames(className)}
      placeholder="blur"
      blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAABAAEDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdABmX/9k="
      priority={priority}
    />
  );
}
